import {Component, Input, OnInit} from "@angular/core";
import {Async} from "@helper/async.decorator";
import {Subject} from "rxjs";
import {RefundRequest} from "@helper/types/refund";

@Component({
	selector: "app-refund-status-popup",
	templateUrl: "./refund-status-popup.component.html",
	styleUrls: ["./refund-status-popup.component.scss"]
})
export class RefundStatusPopupComponent implements OnInit {
	@Async() public close$ = new Subject<void>();
	@Input() public status: RefundRequest;

	public statusText = "";

	public ngOnInit() {
		if (this.status.refundStatus === 4) {
			this.statusText = this.status.processError;
		} else {
			this.statusText = "Статус обработки: " + this.getStatusText(this.status.refundStatus);
		}
	}

	public getStatusText(code: number): string {
		switch (code) {
			case 1:
				return "Начат";
			case 2:
				return "Выполнен";
			case 3:
				return "Отменен";
			default:
				return "Обработан с ошибкой";
		}
	}
}
